'use client';

import { c as _c } from "react/compiler-runtime";
import type { LucideIcon } from 'lucide-react';
import { type Route } from 'next';
import * as React from 'react';
import { LocationSwitcher } from '@/components/layout/location-switcher';
import { NavMain } from '@/components/layout/nav-main';
import { NavUser } from '@/components/layout/nav-user';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from '@/components/ui/sidebar';
import revallyLogoFull from '@/public/revally-logo-full.png';
import revallyLogo from '@/public/revally-logo.webp';
import Image from 'next/image';
export type RevallySidebarMenu = {
  title: string;
  items?: {
    title: string;
    href?: Route;
    icon?: LucideIcon;
    color?: string;
    badge?: string;
    disabled?: boolean;
  }[];
}[];
export function RevallySidebar(t0) {
  const $ = _c(21);
  let footerTopContent;
  let headerContent;
  let menu;
  let props;
  if ($[0] !== t0) {
    ({
      menu,
      headerContent,
      footerTopContent,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = footerTopContent;
    $[2] = headerContent;
    $[3] = menu;
    $[4] = props;
  } else {
    footerTopContent = $[1];
    headerContent = $[2];
    menu = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="w-full h-16 flex items-center justify-center"><Image src={revallyLogo} alt="Revally Logo" width={200} className="w-8 aspect-square mx-auto group-data-[collapsible=icon]:block hidden" priority={true} /><Image src={revallyLogoFull} alt="Revally Logo" width={200} className="w-full h-auto px-18 py-4 group-data-[collapsible=icon]:hidden" priority={true} /></div>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== headerContent) {
    t2 = headerContent ?? <LocationSwitcher />;
    $[6] = headerContent;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <SidebarHeader className="flex justify-center">{t1}{t2}</SidebarHeader>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== menu) {
    t4 = <SidebarContent><NavMain groups={menu} /></SidebarContent>;
    $[10] = menu;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NavUser />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== footerTopContent) {
    t6 = <SidebarFooter>{footerTopContent}{t5}</SidebarFooter>;
    $[13] = footerTopContent;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SidebarRail />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== props || $[17] !== t3 || $[18] !== t4 || $[19] !== t6) {
    t8 = <Sidebar collapsible="icon" {...props} className="mx-2 overflow-hidden">{t3}{t4}{t6}{t7}</Sidebar>;
    $[16] = props;
    $[17] = t3;
    $[18] = t4;
    $[19] = t6;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}